App.Pages.ChangePhone = class ChangePhone extends PF.Page
	{

	static get options()
		{
		return {
			rights: {
				user: true
			},
			path: '/change-phone',
			nameRu: 'Общее - изменение телефона',
		};
		}

	static get template()
		{
		// language=HTML
		return `
            <div class="page">
                <div class="navbar">
                    <div class="navbar-inner">
                        <div class="left">
                            <a href="#" class="link back">
                                <i class="icon icon-back"></i>
                            </a>
                        </div>
                        <div class="center">Изменить телефон</div>
                    </div>
                </div>

                <div class="page-content">

                    <div class="stretch-block">
                        <form class="block" pf="sendCodeForm">

                            <p style="text-align: center">На указанный номер телефона будет отправлено SMS c кодом для
                                смены номера</p>

                            <input type="text" placeholder="Новый номер телефона" pf="phone">

                            <a href="#" class="button button-fill" pf="send">Продолжить</a>
                        </form>

                        <form class="block" pf="changePhoneForm">
                            <input type="text" placeholder="Код подтверждения" pf="code">
                            <input type="password" placeholder="Пароль" pf="pass">

                            <a href="#" class="button button-fill" pf="changePhone">Изменить номер</a>
                        </form>
                    </div>


                </div>

            </div>

		`;
		}

	init()
		{
		super.init();
		this.dom.changePhoneForm.hide();
		this.sendCode = new PF.Form({
			dom: {
				element: this.dom.sendCodeForm,
			},
			fields: {
				phone: {
					type: 'Phone',
					required: true
				},
			},
			submitPfId: 'send',
			errors: {
				sendFail: 'Не удалось отпраить SMS',
				block: 'Вы отправили больше трёх SMS за день. Попробуёте позже или свяжитесь с оператором',
				repeatSignUp: 'Данный номер уже зарегистрирован'
			},

		});
		this.sendCode.on('submit', this.sendStart.bind(this));


		this.changePhone = new PF.Form({
			dom: {
				element: this.dom.changePhoneForm,
			},
			submitPfId: 'changePhone',
			fields: {
				code: {
					type: 'Int',
					required: true,
					fixLen: 5
				},
				pass: {
					type: 'Varchar',
					required: true,
				},
			},
			errors: {
				codeError: 'Неверный код подтверждения',
				passError: 'Неверный пароль'
			}
		});
		this.changePhone.on('submit', this.changePhoneStart.bind(this));
		}

	sendStart()
		{
		app.f7.preloader.show();
		app.ajax('/general/profile/send-change-phone-code', this.sendCode.$data, this.sendFinish.bind(this));
		}

	sendFinish(response)
		{
		app.f7.preloader.hide();
		if (response.status === 'OK')
			{
			this.dom.changePhoneForm.show();
			this.dom.send.text('Отправить ещё раз');
			this.changePhone.$data.phone = response.data.phone;
			}
		else
			{
			this.sendCode.setError(response.error);
			}
		}

	changePhoneStart()
		{
		app.f7.preloader.show();
		app.ajax('/general/profile/change-phone', this.changePhone.$data, this.changePhoneFinish.bind(this));
		}

	changePhoneFinish(response)
		{
		app.f7.preloader.hide();
		if (response.status === 'OK')
			{
			app.router.navigate('/profile');
			app.toast("Номер телефона изменён");
			}
		else
			{
			this.changePhone.setError(response.error);
			}
		}


	};